import Navbar from "../Components/Navbar";
import React, { useState, useRef,useEffect } from "react";
import {
  FaBriefcase,
  FaUserPlus,
  FaFileAlt,
  FaBell,
  FaHandHoldingUsd,FaGraduationCap
} from "react-icons/fa";
import axios from "axios";
import config from "../utils/config";
import { useNavigate, useLocation } from "react-router-dom";
export default function RecruitmentServices() {
    const [selectedType, setSelectedType] = useState("");
      const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    phone_number: "",
    email: "",
    place: "",
    applicant_type: "Job Seeker",
  });
 const navigate = useNavigate();
 useEffect(() => {
   window.scrollTo({
     top: 0,
     left: 0,
     behavior: "instant",
   });
 }, []);
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
console.log("form data is",formData)
    try {
      await axios.post(
  `${config.baseurl}/job_application/`,
  formData
);

     alert(
        "Application submitted successfully"
      );

      setFormData({
        first_name: "",
        last_name: "",
        phone_number: "",
        email: "",
        place: "",
        applicant_type: "Job Seeker",
      });
    } catch (error) {
  console.log("Full Error:", error);

  if (error.response) {
    console.log("Response Data:", error.response.data);
    console.log("Status:", error.response.status);
    alert(error.response.data.message || "Submission failed");
  } else {
    alert("Server connection failed");
  }
}
  };
const formRef = useRef(null);

const scrollToForm = () => {
  formRef.current?.scrollIntoView({
    behavior: "smooth",
    block: "start",
  });
};
  return (
    <>
    <section className="relative min-h-screen text-white overflow-hidden">

  <div className="fixed inset-0 bg-black/40 -z-10"></div>
  <video
    autoPlay
    muted
    loop
    playsInline
    className="fixed inset-0 w-full h-full object-cover -z-10"
    // className="absolute inset-0 w-full h-full object-cover"
  >
    <source src="/videos/bg.mp4" type="video/mp4" />
  </video>

    <div className="fixed inset-0 bg-black/40 -z-10"></div>

  <div className="relative z-10">

    <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">

      <div className="text-center mb-16">
        <h1 className="text-3xl md:text-6xl font-bold mb-6 text-cyan-500">
          Recruitment Services
        </h1>

        <p className="max-w-5xl mx-auto text-lg text-gray-300">
          Connecting talented professionals with leading organizations.
          We help businesses find the right candidates and empower job
          seekers to achieve their career goals.
        </p>
      </div>

      <div className="grid lg:grid-cols-2 gap-12 items-center">

        <div>
          <h2 className="text-4xl font-bold mb-10">
            Why Choose Us
          </h2>

          <div className="space-y-6">
            <div>
              <h3 className="text-xl font-semibold text-cyan-400">
                1. Tailored Talent Solutions
              </h3>
              <p className="text-gray-300 mt-2">
                We understand your hiring needs and provide candidates
                who perfectly align with your company goals.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-cyan-400">
                2. Faster Hiring Process
              </h3>
              <p className="text-gray-300 mt-2">
                Reduce recruitment time through our active talent pool.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-cyan-400">
                3. Experienced Recruiters
              </h3>
              <p className="text-gray-300 mt-2">
                Industry experts dedicated to identifying top talent.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-cyan-400">
                4. End-to-End Support
              </h3>
              <p className="text-gray-300 mt-2">
                From sourcing candidates to onboarding.
              </p>
            </div>

            <div>
              <h3 className="text-xl font-semibold text-cyan-400">
                5. Quality Candidate Network
              </h3>
              <p className="text-gray-300 mt-2">
                Access a vast database of skilled professionals.
              </p>
            </div>
          </div>
        </div>

        <div className="flex justify-center">
          <img
            src="/images/r1.png"
            alt="Recruitment"
            className="w-full max-w-lg rounded-2xl shadow-2xl"
          />
        </div>

      </div>
    </div>

    <div className="max-w-6xl mx-auto px-4 mb-20">

      <div className="bg-black/40 backdrop-blur-md rounded-3xl p-8 md:p-12 border border-white/10">

        <h2 className="text-3xl md:text-5xl font-bold text-center mb-6">
          Ready to Take the Next Step?
        </h2>

     <p className="text-center text-gray-300 max-w-4xl mx-auto">
  Whether you're looking to hire top talent or land your next
  job, our recruitment experts are here to help.
</p>

<div className="flex justify-center mt-8">
  <button
    onClick={scrollToForm}
    className="bg-cyan-500 hover:bg-cyan-600 px-8 py-3 rounded-lg font-semibold transition"
  >
    I am a Job Seeker
  </button>
</div>
      </div>

    </div>
    <div className="max-w-7xl mx-auto px-4 mb-20">

      <div className="text-center mb-12">
        <h2 className="text-4xl font-bold mb-4">
          Find Your Dream Job
        </h2>

        <p className="text-gray-300 max-w-5xl mx-auto">
          At JK Solution Recruitment Services, we believe every candidate
          deserves the right opportunity to grow and thrive.
        </p>
      </div>

      <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">

        <div className="bg-black/40 backdrop-blur-md p-6 rounded-2xl border border-cyan-500/20">
          <FaBriefcase className="text-cyan-400 text-5xl mb-4" />
          <h3 className="text-xl font-semibold mb-3">
            New Hire Onboarding
          </h3>
          <p className="text-gray-300">
            Smooth transition into your new role.
          </p>
        </div>

        <div className="bg-black/40 backdrop-blur-md p-6 rounded-2xl border border-cyan-500/20">
          <FaHandHoldingUsd className="text-cyan-400 text-5xl mb-4" />
          <h3 className="text-xl font-semibold mb-3">
            Compensation Services
          </h3>
          <p className="text-gray-300">
            Salary guidance and offer negotiation support.
          </p>
        </div>

        <div className="bg-black/40 backdrop-blur-md p-6 rounded-2xl border border-cyan-500/20">
          <FaUserPlus className="text-cyan-400 text-5xl mb-4" />
          <h3 className="text-xl font-semibold mb-3">
            Candidate Recruitment
          </h3>
          <p className="text-gray-300">
            Connect with top employers.
          </p>
        </div>

        <div className="bg-black/40 backdrop-blur-md p-6 rounded-2xl border border-cyan-500/20">
          <FaFileAlt className="text-cyan-400 text-5xl mb-4" />
          <h3 className="text-xl font-semibold mb-3">
            Resume Enhancement
          </h3>
          <p className="text-gray-300">
            Improve your resume and profile.
          </p>
        </div>

        <div className="bg-black/40 backdrop-blur-md p-6 rounded-2xl border border-cyan-500/20">
          <FaBell className="text-cyan-400 text-5xl mb-4" />
          <h3 className="text-xl font-semibold mb-3">
            Interview Preparation
          </h3>
          <p className="text-gray-300">
            Career guidance and interview support.
          </p>
        </div>

        <div className="bg-black/40 backdrop-blur-md p-6 rounded-2xl border border-cyan-500/20">
          <FaGraduationCap className="text-cyan-400 text-5xl mb-4" />
          <h3 className="text-xl font-semibold mb-3">
            Career Guidance
          </h3>
          <p className="text-gray-300">
            Training and professional development.
          </p>
        </div>

      </div>
    </div>

    <div ref={formRef} className="max-w-5xl mx-auto px-4 pb-20">

      <div className="bg-black/40 backdrop-blur-md rounded-3xl p-8 md:p-10 border border-cyan-500/20">

        <h2 className="text-center text-4xl font-bold mb-10">
          Application Form
        </h2>

        <form onSubmit={handleSubmit}>
         <div className="grid md:grid-cols-2 gap-6">

  <div>
    <label className="block mb-2 text-sm font-semibold text-cyan-400">
      First Name
    </label>
    <input
      type="text"
      name="first_name"
      placeholder="Enter First Name"
      value={formData.first_name}
      onChange={handleChange}
      required
      className="w-full bg-transparent border border-gray-600 rounded-lg p-3"
    />
  </div>

  <div>
    <label className="block mb-2 text-sm font-semibold text-cyan-400">
      Last Name
    </label>
    <input
      type="text"
      name="last_name"
      placeholder="Enter Last Name"
      value={formData.last_name}
      onChange={handleChange}
      required
      className="w-full bg-transparent border border-gray-600 rounded-lg p-3"
    />
  </div>

  <div>
    <label className="block mb-2 text-sm font-semibold text-cyan-400">
      Phone Number
    </label>
    <input
      type="text"
      name="phone_number"
      placeholder="Enter Phone Number"
      value={formData.phone_number}
      onChange={handleChange}
      required
      className="w-full bg-transparent border border-gray-600 rounded-lg p-3"
    />
  </div>

  <div>
    <label className="block mb-2 text-sm font-semibold text-cyan-400">
      Email Address
    </label>
    <input
      type="email"
      name="email"
      placeholder="Enter Email Address"
      value={formData.email}
      onChange={handleChange}
      required
      className="w-full bg-transparent border border-gray-600 rounded-lg p-3"
    />
  </div>

  <div>
    <label className="block mb-2 text-sm font-semibold text-cyan-400">
      Place
    </label>
    <input
      type="text"
      name="place"
      placeholder="Enter Place"
      value={formData.place}
      onChange={handleChange}
      required
      className="w-full bg-transparent border border-gray-600 rounded-lg p-3"
    />
  </div>

  <div>
    <label className="block mb-2 text-sm font-semibold text-cyan-400">
      Applicant Type
    </label>
    <input
      type="text"
      value="Job Seeker"
      readOnly
      className="w-full bg-gray-800 border border-gray-600 rounded-lg p-3"
    />
  </div>

</div>

          <div className="text-center mt-8">
            <button
              type="submit"
              className="bg-cyan-500 hover:bg-cyan-600 px-8 py-3 rounded-lg font-semibold transition"
            >
              Submit Application
            </button>
          </div>

        </form>

      </div>

    </div>
  <div className="bg-black/70 backdrop-blur-md py-12">

        <div className="max-w-7xl mx-auto px-5">

          <div className="grid md:grid-cols-3 gap-10">

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-3">
                Kerala Branch
              </h3>

              <p className="leading-7">
                1st Floor - JK Building
                <br />
                Kannur, Kannur 670684
                <br />
                Phone: +91 90000 90000
              </p>

              <h3 className="text-xl font-bold text-cyan-400 mt-6 mb-3">
                Tamil Nadu Branch
              </h3>

              <p className="leading-7">
                First Floor, D Block,
                <br />
                JK Park, chennai,
                <br />
                Chennai, Tamil Nadu 600100
                <br />
                Phone: +91 70000 80000
                <br />
                Email: jk@gmail.com
              </p>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                Quick Links
              </h3>

              <ul className="space-y-3">

                <li  className="cursor-pointer" onClick={() => navigate("/home")}>Home</li>
                <li  className="cursor-pointer" onClick={() => navigate("/about")}>About Us</li>
                <li className="cursor-pointer"  onClick={() => navigate("/services")}>Services</li>
                <li  className="cursor-pointer" onClick={() => navigate("/product")}>Products</li>
             

              </ul>

            </div>

            <div>

              <h3 className="text-xl font-bold text-cyan-400 mb-5">
                More Links
              </h3>

              <ul className="space-y-3">

                <li  className="cursor-pointer" onClick={() => navigate("/careers")}>Career</li>
                <li className="cursor-pointer"  onClick={() => navigate("/events")}>Events</li>
                <li  className="cursor-pointer" onClick={() => navigate("/blogs")}>Blogs</li>

              </ul>

            </div>

          </div>

        </div>

      </div>
  </div>

</section>
    </>
  );
}